"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "sourceCreated", {
  enumerable: true,
  get: function get() {
    return _sourceCreated["default"];
  }
});
var _sourceCreated = _interopRequireDefault(require("./sourceCreated"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }